<template>
    <el-dialog title="券码管理" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false" width="1000px">
        <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="抽奖码">
            <el-input v-model="formInline.code" placeholder="请输入码"></el-input>
            </el-form-item>
            <el-form-item label="批次号">
            <el-input v-model="formInline.batch_no" placeholder="请输入批次号"></el-input>
            </el-form-item>
            <el-form-item label="使用状态">
                <el-select v-model="formInline.status">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="未使用" :value="0"></el-option>
                    <el-option label="已中奖" :value="1"></el-option>
                    <el-option label="未中奖" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form>
    </div>
    <div class="product-content">
        <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="id" label="ID" width="100"></el-table-column>
            <el-table-column prop="batch_no" label="批次号"></el-table-column>
            <el-table-column prop="code" label="抽奖码"></el-table-column>
            <el-table-column prop="url" label="链接"></el-table-column>
            <el-table-column prop="status.text" label="状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.status.value == 0" class="gray">{{scope.row.status.text}}</span>
                    <span v-if="scope.row.status.value == 1" class="green">{{scope.row.status.text}}</span>
                    <span v-if="scope.row.status.value == 2" class="red">{{scope.row.status.text}}</span>
                </template>
            </el-table-column>
            <el-table-column label="抽奖记录" width="80">
                <template slot-scope="scope">
                    <el-button @click="recordClick(scope.row)" type="text" v-auth="'/plus/sweepstakes/record/index'" size="small">查看</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="use_time" label="使用时间" width="140"></el-table-column>
            <el-table-column prop="create_time" label="生成时间" width="140"></el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
            :page-size="pageSize" layout="total, prev, pager, next, jumper"
            :total="totalDataNumber">
            </el-pagination>
        </div>
    </div>
  </div>
    </el-dialog>
</template>

<script>
    import SweepstakesApi from '@/api/sweepstakes.js';
    export default {
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '80px',
                /*是否显示*/
                dialogVisible: false,
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*是否加载完成*/
                loading: true,
                /*横向表单数据模型*/
                formInline: {
                    code: '',
                    status: -1,
                    batch_no: '',
                },
            };
        },
        props: ['open_edit','awards_id'],
        created() {
            this.dialogVisible = this.open_edit;
            /*获取列表*/
            this.getData();
        },
        methods: {
            /*搜索查询*/
            onSubmit() {
                this.getData();
            },
            /*搜索查询*/
            recordClick(row) {
                if(row.record_id == 0) {
                    this.$message({
                        message:'暂无记录',
                        type: 'warning'
                    })
                    return false;
                }
                this.$router.push({
                    path : '/plus/sweepstakes/index',
                    query:{
                        type:'record',
                        record_id: row.record_id,
                    }
                })
            },
            /*获取列表*/
            getData() {
                let self = this;
                let Params = this.formInline;
                Params.awards_id = this.awards_id;
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                SweepstakesApi.codeList(Params, true)
                .then(data => {
                    self.loading = false;
                    self.tableData = data.data.list.data;
                    self.totalDataNumber = data.data.list.total
                })
                .catch(error => {});
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },

            /*关闭弹窗*/
            dialogFormVisible(e) {
                this.$emit('closeDialog', {
                    openDialog: false
                })
            },

        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakesawards/part/CodeList.vue